import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import women from "../../images/login-women.png";
import LogoImage from "../../images/Dhroom.svg";
import NoIndex from "../NoIndex";
import "./AdminDashboard.css";
import "bootstrap/dist/css/bootstrap.min.css";
import MyContext from "../../MyContext";
import GoogleOneTap from "../Googleonetab";
import { create } from "qrcode";

const LoginPage = () => {
  const { baseUrl, config, config2 } = useContext(MyContext);
  const navigate = useNavigate();

  // Original state kept intact (names preserved)
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [error, setError] = useState(null);
  const [MobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [MobileNumberError, setMobileNumberError] = useState("");
  const [Otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [step, setstep] = useState(1);
  const [OTPField, setOTPField] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [Lerror, setLerror] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [LoginScreen, setLoginScreen] = useState("LOGIN");
  const [User, setUser] = useState("no user");

  const googleRequestInProgress = useRef(false);

  // Forgot password states
  const [ForgetNumber, setForgetNumber] = useState("");
  const [ForgetStep, setForgetStep] = useState(1);
  const [NewPassword, setNewPassword] = useState("");
  const [ConfirmNewPassword, setConfirmNewPassword] = useState("");
  const [ForgetOtp, setForgetOtp] = useState(["", "", "", "", "", ""]);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // ========== Validation & API flow (kept same) ==========
  function validateInputs() {
    if (MobileNumber.length !== 10) {
      toast.error("Invalid Mobile number");
    } else if (!password) {
      toast.error("Please enter your password");
    } else {
      // Calling LoginCall (v2) to match original behavior
      LoginCall();
    }
  }

  // Send OTP (v1 endpoint)
  const sendOtp = async () => {
    try {
      const BankData = {
        mobile: MobileNumber,
        password: password,
        step: "1",
        otp: "",
        latitude: "",
        longitude: "",
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v1/userLogin`,
        BankData,
        config2
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        setLoginScreen("OTPVERIFICATION");
        setstep(2);
        setOTPField(true);
      } else if (response.data.responseCode === "01") {
        toast.error(response.data.responseMessage);
        setError(true);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error sending OTP");
      console.error("Error sending OTP:", error);
    }
  };

  // Verify OTP (v1 endpoint step 2) - preserved subscription/allowed calls
  const verifyOtp = async () => {
    try {
      const BankData = {
        mobile: MobileNumber,
        password: password,
        step: "2",
        otp: Otp.join(""),
        latitude: "",
        longitude: "",
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v1/userLogin`,
        BankData,
        config2
      );

      if (response.data.responseCode === "00") {
        sessionStorage.setItem("user", JSON.stringify(response.data.response));
        setUser(true);
        await subscriptionDetailsApi(response.data.response.userid);
        await allowedServicesAPI(response.data.response.userid);
        window.location.href = "/Dashboard";
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error verifying OTP");
      console.error("Error during OTP verification:", error);
    }
  };

  const allowedServicesAPI = async (userId) => {
    try {
      const requestBody = { userid: userId };
      const response = await axios.post(
        `${baseUrl}/api/User/getUserAccess`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        sessionStorage.setItem(
          "menuItems",
          JSON.stringify(response.data.response)
        );
      } else {
        // console.log("Failed to get user access");
      }
    } catch (error) {
      // console.log("Error:", error);
    }
  };

  const subscriptionDetailsApi = async (userId) => {
    try {
      const responseBody = { userid: userId };
      const response = await axios.post(
        `${baseUrl}/api/Entitlement/fetchSubscriptionDetails`,
        responseBody,
        config
      );
      if (response.data.responseCode === "00") {
        sessionStorage.setItem("power", "1");
        window.location.href = "/Dashboard";
      } else if (response.data.responseCode === "03") {
        window.location.href = "/Dashboard";
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Main login (v2)
  const LoginCall = async () => {
    if (MobileNumber.length !== 10) {
      toast.error("Invalid Mobile number");
      return;
    }
    if (!password) {
      toast.error("Please enter your password");
      return;
    }

    try {
      const BankData = {
        mobile: MobileNumber,
        password: password,
        latitude: latitude || "",
        longitude: longitude || "",
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v2.0/userLogin`,
        BankData,
        config2
      );

      if (response.data.responseCode === "00") {
        sessionStorage.setItem("user", JSON.stringify(response.data.response));
        setUser(true);
        await subscriptionDetailsApi(response.data.response.userid);
        await allowedServicesAPI(response.data.response.userid);
        window.location.href = "/Dashboard";
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error during login");
      console.error("Error during login:", error);
    }
  };

  // Resend OTP (preserves your logic)
  const ResendOtp = async (stepParam) => {
    toast.info("Resending OTP...");
    try {
      const BankData = {
        mobile: MobileNumber,
        password: password,
        step: 1,
        otp: Otp.join(""),
        latitude: latitude,
        longitude: longitude,
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v1/userLogin`,
        BankData,
        config2
      );
      if (stepParam === "1") {
        toast.success(response.data.responseMessage);
        setUser(response.data.response);
        setstep(2);
        setOTPField(true);
      } else if (stepParam === "2") {
        setUser(response.data.response);
        sessionStorage.setItem("power", "1");
        window.location.href = "/Dashboard";
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error");
      console.error("Error updating Admin login:", error);
    }
  };

  // OTP handlers (improved focus management but same behaviour)
  const handleOtpChange = (e, index) => {
    const val = e.target.value.replace(/[^0-9]/g, "");
    const newOtp = [...Otp];
    newOtp[index] = val;
    setOtp(newOtp);
    if (val !== "" && e.target.nextElementSibling) {
      e.target.nextElementSibling.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const newOtp = [...Otp];
      newOtp[index] = "";
      setOtp(newOtp);
      if (index > 0) {
        const prevInput = e.target.previousElementSibling;
        if (prevInput) prevInput.focus();
      }
    }
  };

  const handleForgotOtpChange = (e, index) => {
    const val = e.target.value.replace(/[^0-9]/g, "");
    const newOtp = [...ForgetOtp];
    newOtp[index] = val;
    setForgetOtp(newOtp);
    if (val !== "" && e.target.nextElementSibling) {
      e.target.nextElementSibling.focus();
    }
    if (val === "" && e.target.previousElementSibling) {
      e.target.previousElementSibling.focus();
    }
  };

  // Forgot password endpoints preserved
  const sendForgetOtp = async () => {
    try {
      const BankData = {
        mobile: ForgetNumber,
        newPassword: "",
        otp: "",
        step: "1",
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v1.0/forgetPassword`,
        BankData,
        config2
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        setLoginScreen("OTPVERIFICATIONFORGET");
        setForgetStep(2);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error sending OTP");
      console.error("Error sending OTP:", error);
    }
  };

  const verifyForgetOtp = async () => {
    try {
      const BankData = {
        mobile: ForgetNumber,
        newPassword: "",
        otp: ForgetOtp.join(""),
        step: "2",
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v1.0/forgetPassword`,
        BankData,
        config2
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        setLoginScreen("RESET_PASSWORD");
        setForgetStep(3);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error verifying OTP");
      console.error("Error verifying OTP:", error);
    }
  };

  const resetPassword = async () => {
    if (NewPassword !== ConfirmNewPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      const BankData = {
        mobile: ForgetNumber,
        newPassword: NewPassword,
        otp: ForgetOtp.join(""),
        step: "3",
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v1.0/forgetPassword`,
        BankData,
        config2
      );

      if (response.data.responseCode === "00") {
        toast.success("Password reset successfully!");
        setLoginScreen("LOGIN");
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error resetting password");
      console.error("Error resetting password:", error);
    }
  };

  function ForgotPassWord() {
    setLoginScreen("FORGOTPASSWORD");
  }

  // Geolocation on mount (preserved)
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        (err) => {
          setLerror(err.message);
        }
      );
    } else {
      setError("Geolocation is not supported by your browser");
    }
  }, []);

  const registerUserAfterGoogleLogin = async (googleUser) => {

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Basic YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU="
    );

    const payload = {
      userid: "1",
      clientName: googleUser.name,
      password: googleUser.email,
      clientNumber: googleUser.email,
      userType: "1",
      onboardingType: "2",
      onboardedBy: "1",
      clientId: "1",
      billingName: googleUser.name,
      allowedIp: "",
      firstName: googleUser.firstName,
      lastName: googleUser.lastName,
    };

    const response = await fetch(`${baseUrl}/api/User/register`,{
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(payload),
    });

    // console.log(" HTTP STATUS:", response.status);

    const result = await response.json();
    // console.log(" REGISTER API RESPONSE:", result);

    return result;
  };

  const handleGoogleResponse = async (response) => {
    try {
      if (!response?.credential) return;

      const base64Url = response.credential.split(".")[1];
      const decodedData = JSON.parse(
        atob(base64Url.replace(/-/g, "+").replace(/_/g, "/"))
      );

      const [firstName, ...rest] = decodedData.name.split(" ");
      const lastName = rest.join(" ");

      const googleUser = {
        name: decodedData.name,
        email: decodedData.email,
        firstName,
        lastName,
      };

      const registerResult = await registerUserAfterGoogleLogin(googleUser);

      if (registerResult?.responseCode !== "00") {
        toast.error(registerResult?.responseMessage || "Registration failed");
        return;
      }
      sessionStorage.setItem("power", "1");
      const userData = registerResult.response;
      // sessionStorage.setItem("power", "1");

      sessionStorage.setItem("user", JSON.stringify(userData));

      toast.success("Login successful");

      setTimeout(() => {
        window.location.href = "/Dashboard";
      }, 1000);
    } catch (err) {
      console.error("GOOGLE LOGIN ERROR", err);
      toast.error("Something went wrong");
    }
  };

  return (
    <div
      className="container-fluid vh-100 d-flex align-items-center justify-content-center"
      style={{ background: "linear-gradient(180deg,#eaf2ff 0%, #ffffff 100%)" }}
    >
      <NoIndex />
      <ToastContainer position="top-center" />
      <div
        className="row w-100 gx-0 shadow-lg rounded overflow-hidden"
        style={{ maxWidth: 1100 }}
      >
        {/* Left illustration */}
        <div
          className="col-md-6 d-none d-md-flex bg-primary align-items-center justify-content-center"
          style={{ minHeight: 520 }}
        >
          <div className="text-center text-white p-4">
            <img
              src={women}
              alt="Illustration"
              className="img-fluid rounded mb-3"
              style={{ maxHeight: 320 }}
            />
            <h3 className="fw-bold">Welcome to Dhroom</h3>
            <p className="small opacity-75">
              Secure admin access · subscriptions · services
            </p>
          </div>
        </div>

        {/* Right form */}
        <div className="col-md-6 bg-white p-5">
          <div className="d-flex align-items-center mb-4">
            <img src={LogoImage} alt="Logo" height={40} />
          </div>

          {/* LOGIN SCREEN */}
          {LoginScreen === "LOGIN" && (
            <>
             
              <h2 className="h5 fw-bold mb-1">
                Get started with your phone number
              </h2>
              <p className="text-muted mb-4">
                Enter your credentials to sign in
              </p>

              <div className="mb-3 d-flex">
                <select className="form-select me-2" style={{ maxWidth: 110 }}>
                  <option value="+91">+91</option>
                </select>
                <input
                  type="tel"
                  className={`form-control ${error ? "is-invalid" : ""}`}
                  placeholder="Phone number"
                  value={MobileNumber}
                  onChange={(e) =>
                    setMobileNumber(e.target.value.replace(/[^0-9]/g, ""))
                  }
                />
              </div>

              <div className="mb-3 position-relative">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  placeholder="Enter Your Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  type="button"
                  className="btn btn-sm position-absolute"
                  style={{
                    right: 8,
                    top: 8,
                    color: "#0d6efd",
                    background: "transparent",
                    border: "none",
                  }}
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? "Hide" : "Show"}
                </button>
              </div>

              <div className="d-flex align-items-center justify-content-between mb-3">
                <button
                  type="button"
                  className="btn btn-primary px-4"
                  onClick={validateInputs}
                >
                  Continue
                </button>
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => setLoginScreen("FORGOTPASSWORD")}
                >
                  Forgot password?
                </button>
              </div>
            </>
          )}
          <div className="mt-1">
            <GoogleOneTap onSuccess={handleGoogleResponse} />
          </div>
          {/* OTP VERIFICATION */}
          {LoginScreen === "OTPVERIFICATION" && (
            <>
              <h2 className="h5 fw-bold mb-1">OTP Verification</h2>
              <p className="text-muted mb-3">
                Enter the 6-digit code sent to {MobileNumber}
              </p>

              <div className="d-flex gap-2 justify-content-center mb-3">
                {Otp.map((val, idx) => (
                  <input
                    key={idx}
                    className="form-control text-center"
                    style={{ width: 48 }}
                    type="text"
                    maxLength="1"
                    value={val}
                    onChange={(e) => handleOtpChange(e, idx)}
                    onKeyDown={(e) => handleKeyDown(e, idx)}
                  />
                ))}
              </div>

              <div className="d-flex gap-2">
                <button
                  type="button"
                  className="btn btn-primary flex-grow-1"
                  onClick={verifyOtp}
                >
                  Verify & Continue
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => ResendOtp("1")}
                >
                  Re-send OTP
                </button>
              </div>
            </>
          )}

          {/* FORGOT PASSWORD */}
          {LoginScreen === "FORGOTPASSWORD" && (
            <>
              <h2 className="h5 fw-bold mb-1">Forgot Password?</h2>
              <p className="text-muted mb-3">
                Enter your registered phone number
              </p>

              <div className="mb-3 d-flex">
                <select className="form-select me-2" style={{ maxWidth: 110 }}>
                  <option value="+91">+91</option>
                </select>
                <input
                  type="tel"
                  className={`form-control ${error ? "is-invalid" : ""}`}
                  placeholder="Phone number"
                  value={ForgetNumber}
                  onChange={(e) =>
                    setForgetNumber(e.target.value.replace(/[^0-9]/g, ""))
                  }
                />
              </div>

              <div className="d-flex gap-2">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={sendForgetOtp}
                >
                  Continue
                </button>
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => setLoginScreen("LOGIN")}
                >
                  Back to login
                </button>
              </div>
            </>
          )}

          {/* OTP VERIFICATION FOR FORGOT */}
          {LoginScreen === "OTPVERIFICATIONFORGET" && (
            <>
              <h2 className="h5 fw-bold mb-1">OTP Verification</h2>
              <p className="text-muted mb-3">
                Enter the 6-digit code sent to {ForgetNumber}
              </p>

              <div className="d-flex gap-2 justify-content-center mb-3">
                {ForgetOtp.map((val, idx) => (
                  <input
                    key={idx}
                    className="form-control text-center"
                    style={{ width: 48 }}
                    type="text"
                    maxLength="1"
                    value={val}
                    onChange={(e) => handleForgotOtpChange(e, idx)}
                    onKeyDown={(e) => handleKeyDown(e, idx)}
                  />
                ))}
              </div>

              <div className="d-flex gap-2">
                <button
                  type="button"
                  className="btn btn-primary flex-grow-1"
                  onClick={verifyForgetOtp}
                >
                  Continue
                </button>
              </div>
            </>
          )}

          {/* RESET PASSWORD */}
          {LoginScreen === "RESET_PASSWORD" && (
            <>
              <h2 className="h5 fw-bold mb-1">Reset Password</h2>
              <p className="text-muted mb-3">
                Set a new password for {ForgetNumber}
              </p>

              <div className="mb-3">
                <input
                  type="password"
                  className="form-control mb-2"
                  placeholder="New Password"
                  value={NewPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                <input
                  type="password"
                  className="form-control"
                  placeholder="Confirm New Password"
                  value={ConfirmNewPassword}
                  onChange={(e) => setConfirmNewPassword(e.target.value)}
                />
              </div>

              <div className="d-flex gap-2">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={resetPassword}
                >
                  Reset Password
                </button>
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => setLoginScreen("LOGIN")}
                >
                  Cancel
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
